import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { Form, Button, Row, Col } from 'react-bootstrap'

import { deleteGroup } from '../actions/systemOwnerStudyActions'

import EmaAx from '../../ema_module/components/EmaAx'
import getDefaultEmaAx from '../../ema_module/utils/getDefaultEmaAx'
import resetErrorState from '../utils/resetErrorState'
import QuestionnaireListInfo from './QuestionnaireListInfo'
import EMA_OR_EMI from '../../ema_or_emi'
import JitaiSetting from '../../jitai_module/components/JitaiSetting'
import JitaiGroupAssignmentSetting from '../../jitai_module/components/JitaiGroupAssignmentSetting'
import JitaiOptionalTxPackageAssignmentSetting from '../../jitai_module/components/JitaiOptionalTxPackageAssignmentSetting'
import getDefaultJitaiSetting from '../../jitai_module/utils/getDefaultJitaiSetting'
import getDefaultJitaiGroupAssignmentSetting from '../../jitai_module/utils/getDefaultJitaiGroupAssignmentSetting'
import getDefaultJitaiOptionalTxPackageAssignmentSetting from '../../jitai_module/utils/getDefaultJitaiOptionalTxPackageAssignmentSetting'
import { useSelector } from 'react-redux'

export const SystemOwnerStudyGroup = ({ group, studyId, study, stage, qxList }) => {
  const dispatch = useDispatch()

  const [name, setName] = useState('')
  const [groupNum, setGroupNum] = useState('')
  const [emaList, setEmaList] = useState([])
  const [jitaiSettingList, setJitaiSettingList] = useState([])
  const [nextStageGroupAssignmentSettings, setNextStageGroupAssignmentSettings] = useState([])
  const [nextStageOptionalTxPackageSettings, setNextStageOptionalTxPackageSettings] = useState([])
  const [qxAxList, setQxAxList] = useState([])
  const [noSubmissionLimitList, setNoSubmissionLimitList] = useState([])
  const [loadedQxList, setLoadedQxList] = useState([])

  // JITAI data - read from redux (fetched at SystemOwnerStudyEditScreen level)
  const jitaiMessageList = useSelector((state) => state.jitaiMessageList)
  const { jitaiMessages } = jitaiMessageList
  
  const jitaiVariableList = useSelector((state) => state.jitaiVariableList)
  const { jitaiVariables } = jitaiVariableList
  
  const jitaiDecisionRuleList = useSelector((state) => state.jitaiDecisionRuleList)
  const { jitaiDecisionRules } = jitaiDecisionRuleList

  const jitaiRespList = useSelector((state) => state.jitaiRespList)
  const { jitaiResps } = jitaiRespList

  //For later versions, add diary and questionnaire

  useEffect(() => {
    setName(group.name)
    setGroupNum(group.group_num)
    setEmaList(group.ema_list)
    setJitaiSettingList(group.jitai_setting_list || [])
    setNextStageGroupAssignmentSettings(group.next_stage_group_assignment_settings || [])
    setNextStageOptionalTxPackageSettings(group.next_stage_optional_tx_package_settings || [])
    setQxAxList(group.questionnaire_list)
    setNoSubmissionLimitList(group.no_submission_limit_list)
    setLoadedQxList(qxList)
    // JITAI data fetching is now handled at the SystemOwnerStudyEditScreen level to avoid duplicate requests
  }, [group, qxList])

  const deleteGroupHandler = () => {
    if (
      window.confirm(
        'This operation will remove unsaved changes. Please save changes first if you have not done that. Are you sure you want to go ahead?'
      )
    ) {
      resetErrorState(dispatch)
      dispatch(deleteGroup(group.stage, groupNum, study && study.settingsSetId))
    }
  }

  const addEMASettings = () => {
    group.ema_list = [...group.ema_list, getDefaultEmaAx()]
    setEmaList(group.ema_list)
  }

  const deleteEMASettings = (index) => {
    if (window.confirm('Confirm?')) {
      let temp = []
      for (let i = 0; i < group.ema_list.length; ++i) {
        if (i === index) {
          continue
        } else {
          temp.push(group.ema_list[i])
        }
      }
      group.ema_list = temp
      setEmaList(temp)
    }
  }

  const addJitaiSettings = () => {
    if (!group.jitai_setting_list) {
      group.jitai_setting_list = []
    }
    group.jitai_setting_list = [...group.jitai_setting_list, getDefaultJitaiSetting()]
    setJitaiSettingList(group.jitai_setting_list)
  }

  const deleteJitaiSettings = (index) => {
    let temp = []
    for (let i = 0; i < group.jitai_setting_list.length; ++i) {
      if (i === index) {
        continue
      } else {
        temp.push(group.jitai_setting_list[i])
      }
    }
    group.jitai_setting_list = temp
    setJitaiSettingList(temp)
  }

  const addGroupAssignmentSetting = () => {
    if (!group.next_stage_group_assignment_settings) {
      group.next_stage_group_assignment_settings = []
    }
    group.next_stage_group_assignment_settings = [...group.next_stage_group_assignment_settings, getDefaultJitaiGroupAssignmentSetting()]
    setNextStageGroupAssignmentSettings(group.next_stage_group_assignment_settings)
  }

  const deleteGroupAssignmentSetting = (index) => {
    let temp = []
    for (let i = 0; i < group.next_stage_group_assignment_settings.length; ++i) {
      if (i === index) {
        continue
      } else {
        temp.push(group.next_stage_group_assignment_settings[i])
      }
    }
    group.next_stage_group_assignment_settings = temp
    setNextStageGroupAssignmentSettings(temp)
  }

  const addOptionalTxPackageSetting = () => {
    if (!group.next_stage_optional_tx_package_settings) {
      group.next_stage_optional_tx_package_settings = []
    }
    group.next_stage_optional_tx_package_settings = [...group.next_stage_optional_tx_package_settings, getDefaultJitaiOptionalTxPackageAssignmentSetting()]
    setNextStageOptionalTxPackageSettings(group.next_stage_optional_tx_package_settings)
  }

  const deleteOptionalTxPackageSetting = (index) => {
    let temp = []
    for (let i = 0; i < group.next_stage_optional_tx_package_settings.length; ++i) {
      if (i === index) {
        continue
      } else {
        temp.push(group.next_stage_optional_tx_package_settings[i])
      }
    }
    group.next_stage_optional_tx_package_settings = temp
    setNextStageOptionalTxPackageSettings(temp)
  }

  // Get participant groups from the next stage
  const getNextStageParticipantGroups = () => {
    if (!study || !stage) return []
    const currentStageNum = stage.stage_num
    const nextStage = study.stage_list.find(s => s.stage_num === currentStageNum + 1)
    if (!nextStage) return []
    return nextStage.participant_group_list || []
  }

  const hasOptionalModulesInNextStage = () => {
    if (!study || !stage) return false
    const nextStage = study.stage_list.find((s) => s.stage_num === stage.stage_num + 1)
    if (!nextStage?.participant_group_list) return false
    for (const g of nextStage.participant_group_list) {
      if (!g.tx_package_list) continue
      for (const pkg of g.tx_package_list) {
        const isValidObjectId =
          pkg._id &&
          typeof pkg._id === 'string' &&
          pkg._id.length === 24 &&
          /^[0-9a-fA-F]{24}$/.test(pkg._id)
        if (pkg.is_optional === true && isValidObjectId) return true
      }
    }
    return false
  }

  const headingStyle = {
    fontSize: '1.3rem',
    fontWeight: 'bold',
    marginBottom: '0.8rem',
  }

  const updateSingleQxList = async (e, type) => {
    let tempList

    if (type === 'qxAx') {
      tempList = JSON.parse(JSON.stringify(qxAxList))
    } else {
      //No submission limit
      tempList = JSON.parse(JSON.stringify(noSubmissionLimitList))
    }
    let removeOption = false
    for (let i = 0; i < tempList.length; ++i) {
      if (tempList[i] === e.target.value) {
        tempList.splice(i, 1)
        removeOption = true
      }
    }
    if (removeOption === false) {
      tempList.push(e.target.value)
    }
    if (type === 'qxAx') {
      group.questionnaire_list = tempList
      setQxAxList(tempList)
    } else {
      group.no_submission_limit_list = tempList
      setNoSubmissionLimitList(tempList)
    }
  }

  return (
    <>
      <hr />
      <div>
        <h2 style={headingStyle}>Participant Group {group.group_num}</h2>
        {group.group_num > 1 && (
          <Button
            variant='danger'
            style={{ float: 'right' }}
            onClick={deleteGroupHandler}
          >
            Delete Group
          </Button>
        )}
      </div>

      <Form>
        <Form.Group controlId={'groupName_' + group._id}>
          <Form.Label style={{ whiteSpace: 'normal' }}>Group Name</Form.Label>
          <Form.Control
            type='text'
            value={name}
            onChange={(e) => {
              group.name = e.target.value
              setName(e.target.value)
            }}
          ></Form.Control>
        </Form.Group>

        {studyId !== '63b756c6bb5dbb002a2a06a3' && jitaiDecisionRules && (
          <div style={{ marginBottom: '18px' }}>
            <Form.Label style={{ whiteSpace: 'normal', marginBottom: '10px' }}>
              Next Stage Group Assignment Settings
            </Form.Label>

            {jitaiDecisionRules.filter(rule => rule.type === 'groupAssignment').length === 0 ? (
              <div style={{ padding: '10px', backgroundColor: '#f8f9fa', border: '1px solid #dee2e6', borderRadius: '4px' }}>
                <p style={{ margin: 0, color: '#6c757d', whiteSpace: 'normal', wordWrap: 'break-word' }}>
                  You need to create at least one Group Assignment JITAI decision rule to specify under what circumstances a participant will be assigned to another participant group in the next stage.
                </p>
              </div>
            ) : getNextStageParticipantGroups().length === 0 ? (
              <div style={{ padding: '10px', backgroundColor: '#f8f9fa', border: '1px solid #dee2e6', borderRadius: '4px' }}>
                <p style={{ margin: 0, color: '#6c757d', whiteSpace: 'normal', wordWrap: 'break-word' }}>
                  No participant groups available in the next stage. Add groups to the next stage first.
                </p>
              </div>
            ) : (
              <>
                {nextStageGroupAssignmentSettings.map((setting, index) => (
                  <JitaiGroupAssignmentSetting
                    key={'group_assignment_setting' + group._id + index}
                    group={group}
                    index={index}
                    jitai_decision_rules={jitaiDecisionRules || []}
                    next_stage_participant_groups={getNextStageParticipantGroups()}
                    handleDelete={() => {
                      deleteGroupAssignmentSetting(index)
                    }}
                  />
                ))}

                <Row>
                  <Col md={12}>
                    <Button
                      style={{ width: '100%', marginTop: '5px' }}
                      variant='primary'
                      onClick={addGroupAssignmentSetting}
                    >
                      Add Group Assignment Setting
                    </Button>
                  </Col>
                </Row>
              </>
            )}
          </div>
        )}

        {studyId !== '63b756c6bb5dbb002a2a06a3' && jitaiDecisionRules && (
          <div style={{ marginBottom: '18px' }}>
            <Form.Label style={{ whiteSpace: 'normal', marginBottom: '10px' }}>
              Next Stage Optional Treatment Chapters Settings
            </Form.Label>

            {jitaiDecisionRules.filter(rule => rule.type === 'optionalTxPackageAssignment').length === 0 ? (
              <div style={{ padding: '10px', backgroundColor: '#f8f9fa', border: '1px solid #dee2e6', borderRadius: '4px' }}>
                <p style={{ margin: 0, color: '#6c757d', whiteSpace: 'normal', wordWrap: 'break-word' }}>
                  You need to create at least one Optional Treatment Chapter Assignment JITAI decision rule to specify under what circumstances optional treatment chapters will be assigned.
                </p>
              </div>
            ) : !hasOptionalModulesInNextStage() ? (
              <div style={{ padding: '10px', backgroundColor: '#f8f9fa', border: '1px solid #dee2e6', borderRadius: '4px' }}>
                <p style={{ margin: 0, color: '#6c757d', whiteSpace: 'normal', wordWrap: 'break-word' }}>
                  No optional treatment chapters available in the next stage. Please mark treatment chapters as &quot;Optional Module&quot; on at least one next-stage participant group and save the study first, then try adding optional treatment chapter settings again.
                </p>
              </div>
            ) : (
              <>
                {nextStageOptionalTxPackageSettings.map((setting, index) => (
                  <JitaiOptionalTxPackageAssignmentSetting
                    key={'optional_tx_package_setting' + group._id + index}
                    group={group}
                    index={index}
                    jitai_decision_rules={jitaiDecisionRules || []}
                    study={study}
                    stage={stage}
                    handleDelete={() => {
                      deleteOptionalTxPackageSetting(index)
                    }}
                  />
                ))}

                <Row>
                  <Col md={12}>
                    <Button
                      style={{ width: '100%', marginTop: '5px' }}
                      variant='primary'
                      onClick={addOptionalTxPackageSetting}
                    >
                      Add Optional Treatment Chapter Setting
                    </Button>
                  </Col>
                </Row>
              </>
            )}
          </div>
        )}

        {loadedQxList && (
          <>
            <div style={{ marginBottom: '18px' }}>
              <Form.Label style={{ whiteSpace: 'normal', marginBottom: '0px' }}>
                EMA Assessments
              </Form.Label>

              {(group.ema_list || []).map((emaAx, index) => (
                <EmaAx
                  key={'ema_settings' + group._id + index}
                  group={group}
                  index={index}
                  qx_list={loadedQxList}
                  handleDelete={() => {
                    deleteEMASettings(index)
                  }}
                ></EmaAx>
              ))}

              <Row>
                <Col md={12}>
                  <Button
                    style={{ width: '100%', marginTop: '5px' }}
                    variant='primary'
                    onClick={addEMASettings}
                  >
                    Add EMA Settings
                  </Button>
                </Col>
              </Row>
            </div>

            {jitaiVariables && jitaiVariables.length > 0 && 
             jitaiMessages && jitaiMessages.length > 0 && 
             jitaiDecisionRules &&
             loadedQxList && loadedQxList.length > 0 &&
             studyId !== '63b756c6bb5dbb002a2a06a3' && (
              <div style={{ marginBottom: '18px' }}>
                <Form.Label
                  style={{ whiteSpace: 'normal', marginBottom: '0px' }}
                >
                  JITAI Settings
                </Form.Label>

                {(group.jitai_setting_list || []).map((jitaiSetting, index) => (
                  <JitaiSetting
                    key={'jitai_settings' + group._id + index}
                    group={group}
                    index={index}
                    qx_list={loadedQxList}
                    jitai_variables={jitaiVariables || []}
                    jitai_messages={jitaiMessages || []}
                    jitai_decision_rules={jitaiDecisionRules || []}
                    jitai_resps={jitaiResps || []}
                    handleDelete={() => {
                      deleteJitaiSettings(index)
                    }}
                  />
                ))}

                <Row>
                  <Col md={12}>
                    <Button
                      style={{ width: '100%', marginTop: '5px' }}
                      variant='primary'
                      onClick={addJitaiSettings}
                    >
                      Add JITAI Settings
                    </Button>
                  </Col>
                </Row>
              </div>
            )}

            <Form.Group controlId={'groupQx_' + group._id}>
              {EMA_OR_EMI === 'ema' ? (
                <>
                  <Form.Label style={{ whiteSpace: 'normal' }}>
                    Assessments that require one-time response at this stage
                    (Click to select/unselect)
                  </Form.Label>
                  <Form.Control
                    as='select'
                    value={qxAxList}
                    onChange={() => {}}
                    onClick={async (e) => {
                      await updateSingleQxList(e, 'qxAx')
                    }}
                    multiple
                  >
                    {loadedQxList.map((qx) => (
                      <option key={qx._id + group._id} value={qx._id}>
                        {qx.chin_name} ({qx.abbrev})
                      </option>
                    ))}
                  </Form.Control>
                  <Row>
                    <Col md={12}>
                      <QuestionnaireListInfo
                        group={group}
                        qxList={qxAxList.map((qxId) =>
                          loadedQxList.find((qx) => qx._id === qxId)
                        )}
                      ></QuestionnaireListInfo>
                    </Col>
                  </Row>
                </>
              ) : (
                qxAxList &&
                qxAxList.length > 0 && (
                  <>
                    <Form.Label style={{ whiteSpace: 'normal' }}>
                      Assessments specified in treatment materials that require
                      one-time response at this stage
                    </Form.Label>
                    <ul>
                      {loadedQxList
                        .filter((qx) =>
                          qxAxList.find((x) => String(x) === String(qx._id))
                        )
                        .map((qx) => (
                          <li>
                            {qx.chin_name} ({qx.abbrev})
                          </li>
                        ))}
                    </ul>
                  </>
                )
              )}
            </Form.Group>

            <Form.Group controlId={'groupUnlimited_' + group._id}>
              {EMA_OR_EMI === 'ema' ? (
                <>
                  <Form.Label style={{ whiteSpace: 'normal' }}>
                    Assessments that allow anytime and unlimited responses
                    (Click to select/unselect)
                  </Form.Label>
                  <Form.Control
                    as='select'
                    value={noSubmissionLimitList}
                    onChange={() => {}}
                    onClick={async (e) => {
                      await updateSingleQxList(e, 'noSubmissionLimit')
                    }}
                    multiple
                  >
                    {loadedQxList.map((qx) => (
                      <option key={qx._id + group._id} value={qx._id}>
                        {qx.chin_name} ({qx.abbrev})
                      </option>
                    ))}
                  </Form.Control>
                </>
              ) : (
                noSubmissionLimitList &&
                noSubmissionLimitList.length > 0 && (
                  <>
                    <Form.Label style={{ whiteSpace: 'normal' }}>
                      Assessments specified in treatment materials that allow
                      anytime and unlimited responses
                    </Form.Label>
                    <ul>
                      {loadedQxList
                        .filter((qx) =>
                          noSubmissionLimitList.find(
                            (x) => String(x) === String(qx._id)
                          )
                        )
                        .map((qx) => (
                          <li>
                            {qx.chin_name} ({qx.abbrev})
                          </li>
                        ))}
                    </ul>
                  </>
                )
              )}
            </Form.Group>
          </>
        )}
      </Form>
    </>
  )
}

export default SystemOwnerStudyGroup
